module.exports = __webpack_public_path__ + "img/empty-map.2c110979.svg";